import { useEffect, useRef, useState } from "react";
import { adminApi } from "@/lib/api";

export default function ConstantContactConnection({ settings, onConnected }) {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const started = useRef(false);
  const configured = settings?.has_client_id && settings?.has_client_secret;
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (!params.has("cc_callback") || started.current) return;
    started.current = true;
    const code = params.get("code"), state = params.get("state"), denied = params.get("error");
    window.history.replaceState(null, "", "/admin?tab=settings");
    const expected = sessionStorage.getItem("cc_oauth_state");
    sessionStorage.removeItem("cc_oauth_state");
    if (!state || state !== expected) { setMessage("Could not verify this connection request. Please click Connect again in this browser."); return; }
    if (denied || !code) { setMessage("Authorization was not completed. Your existing settings have not changed."); return; }
    setBusy(true);
    adminApi.post("/admin/settings/constant-contact/complete", { code, state })
      .then(({ data }) => { onConnected(data); setMessage("Constant Contact connected. Choose your List ID and enable sync when ready."); })
      .catch(error => setMessage(error?.response?.data?.detail || "Could not complete the connection. Please try again."))
      .finally(() => setBusy(false));
  }, [onConnected]);
  const connect = async () => {
    setBusy(true); setMessage("");
    try {
      const { data } = await adminApi.post("/admin/settings/constant-contact/connect");
      sessionStorage.setItem("cc_oauth_state", data.state);
      window.location.assign(data.authorization_url);
    } catch (error) { setMessage(error?.response?.data?.detail || "Could not start the connection."); setBusy(false); }
  };
  return <div className="space-y-3 rounded border border-gray-200 bg-gray-50 p-4">
    <p className="font-bold">{settings?.connected_at ? "Account authorization saved" : "Connect your Constant Contact account"}</p>
    <p className="text-sm text-gray-600">Sign in to Constant Contact and approve access to your contacts. You'll return here automatically.</p>
    <button type="button" disabled={busy || !configured} onClick={connect} className="rounded bg-rc-red px-5 py-3 text-sm font-bold text-white disabled:opacity-50">{busy ? "Connecting…" : settings?.connected_at ? "Reconnect Constant Contact" : "Connect Constant Contact"}</button>
    {!configured && <p className="text-sm text-gray-600">First save the Client ID and Client Secret under App setup below.</p>}
    {message && <p role="status" className="text-sm text-rc-charcoal">{message}</p>}
  </div>;
}
